/* eslint-disable no-redeclare, no-shadow, no-unused-vars, max-params, no-use-before-define, max-len, quotes, curly, complexity, @typescript-eslint/no-empty-interface, prettier/prettier */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.7.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { ApiResponseDataType, request, RequestCustomConfigType } from './api.base';

export interface JSONResult {
  data?: any | undefined;
  msg?: string | undefined;
  /** 业务成功时_返回 ok */
  result?: string | undefined;
}

export interface PaidVersion {
  /** 人数 */
  cnt?: number;
  /** 创建时间 */
  create_time?: number | undefined;
  /** 权益到期时间 */
  end_time?: number | undefined;
  /** 付费权益是否正在生效 */
  is_paid_effective?: boolean | undefined;
  /** 是否顶级套餐；无法再进行升级 */
  is_top_member?: boolean | undefined;
  is_top_member_cnt?: boolean | undefined;
  /** 试用期是否过期_现在只有应用是有试用期的_ */
  is_trial_expired?: boolean | undefined;
  /** 应用套餐时：0是免费_1是试用_>0 则是付费的套餐id; 工作区套餐时：0是没有购买套餐_>0 则是付费的套餐id */
  member_id?: number | undefined;
  /** 权益开始时间 */
  start_time?: number | undefined;
  /** 套餐名称 */
  subject?: string;
  /** 如果是试用期_正在试用的天数_试用天数 */
  trial_period?: number | undefined;
}

export interface ReqAdminAppRightExpired {
  /** 三方平台id */
  platform_id?: string | undefined;
  /** 三方应用id */
  third_app_id?: string | undefined;
}

export interface ReqAdminAppTrialExpired {
  /** 三方平台id */
  platform_id?: string | undefined;
  /** 三方应用id */
  third_app_id?: string | undefined;
}

export interface ReqAdminTeamRightExpired {
  /** 团队id */
  team_id?: number | undefined;
}

export interface ReqAdminTplAppCreate {
  /** 三方低代码平台id */
  platform_id?: string | undefined;
  /** 团队id */
  team_id?: number | undefined;
  /** 模板id */
  tpl_id?: string | undefined;
}

export interface ReqAppCreate {
  /** 低代码平台id */
  platform_id: string;
  /** 对应顶级团队id,非必填 */
  team_id?: number | undefined;
}

export interface ReqAppCreateByTpl {
  /** 低代码平台id */
  platform_id: string;
  /** 指定的顶级团队id,非必填 */
  team_id?: number | undefined;
  /** 模板id */
  tpl_id: string;
}

export interface ReqAppDelete {
  /** 低代码平台id */
  platform_id: string;
  /** 应用所在的顶级团队id,检验需要 */
  team_id: number;
  /** 应用id */
  third_app_id: string;
  /** 三方工作区id,检验需要 */
  third_ws_id: string;
}

export interface ReqBannerUserHotSearchDelete {}

export interface ReqBlackListInspect {
  /** 当前页面的完成url; 如：https://xx.xx.cn/f/ss */
  url: string;
}

export interface ReqMiddlePageAppPreCheck {
  /** 检验方式；0 全检验；1 去除用户工作区匹配检验 */
  mode?: number | undefined;
  /** 低代码平台id */
  platform_id: string;
  /** 非必须_三方可能需要的登录后重定向的链接 */
  redirect_url?: string | undefined;
  /** 顶级团队id */
  team_id: number;
  /** 三方应用id */
  third_app_id: string;
  /** 三方工作区id */
  third_ws_id: string;
}

export interface ReqServerAppAccessRedirectUrl {
  /** 令牌 */
  access_token?: string | undefined;
}

export interface ReqServerAppRightsIncrease {
  /** 用户购买权益的持续时间或者数量_单位_天 */
  count?: number | undefined;
  /** 用户下单时权益结束时间 */
  cur_duration_expires?: number | undefined;
  /** 用户下单时套餐信息 */
  cur_member_id?: number | undefined;
  /** 用户下单时权益数 */
  cur_numeric_value?: number | undefined;
  /** 支付的套餐id */
  member_id?: number | undefined;
  /** 用户在指定低代码合作商下的open_id */
  open_id?: string | undefined;
  /** 平台id */
  platform_id?: string | undefined;
  /** 购买的类型 */
  purchase_type?: number | undefined;
  /** 商品类别（需在支付后台注册） */
  subject?: string | undefined;
  /** 团队id */
  team_id?: number | undefined;
  /** 三方应用id */
  third_app_id?: string | undefined;
  /** 支付金额 */
  total_fee?: string | undefined;
}

export interface ReqServerInviteConfirmCb {
  /** 团队id */
  partner_id?: number | undefined;
  /** 用户id */
  user_id?: string | undefined;
  /** 用户名称 */
  user_name?: string | undefined;
  /** 用户头像 */
  user_pic?: string | undefined;
}

export interface ReqServerPayOrderCb {
  /** 数量（正整数_如会员天数_特权次数等） */
  count?: string | undefined;
  /** 订单创建时间戳 */
  create_time?: string | undefined;
  /** 商品描述 */
  desc?: string | undefined;
  /** 扩展数据 */
  extra?: string | undefined;
  /** 订单号 */
  order_id?: string | undefined;
  /** 商品类别（需在支付后台注册） */
  subject?: string | undefined;
  /** 支付金额 */
  total_fee?: string | undefined;
  /** 用户ID */
  userid?: string | undefined;
}

export interface ReqServerPaymentRegisterOrder {
  /** 低代码平台的ak */
  appid?: string | undefined;
  /** 合作方自己的订单号 */
  billno?: string | undefined;
  /** 用户的did */
  did?: string | undefined;
}

export interface ReqServerTeamRightsIncrease {
  /** 用户购买权益的持续时间或者数量_单位_天 */
  count?: number | undefined;
  /** 用户下单时权益结束时间 */
  cur_duration_expires?: number | undefined;
  /** 用户下单时套餐信息 */
  cur_member_id?: number | undefined;
  /** 用户下单时权益数 */
  cur_numeric_value?: number | undefined;
  /** 支付的套餐id */
  member_id?: number | undefined;
  /** 购买商品的人数 */
  numberic_value?: number | undefined;
  /** 用户在指定低代码合作商下的open_id */
  open_id?: string | undefined;
  /** 平台id */
  platform_id?: string | undefined;
  /** 购买的类型 */
  purchase_type?: number | undefined;
  /** 商品类别（需在支付后台注册） */
  subject?: string | undefined;
  /** 团队id */
  team_id?: number | undefined;
  /** 支付金额 */
  total_fee?: string | undefined;
}

export interface ReqTeamCreate {}

export interface ReqTeamMemberDisable {
  /** 顶级团队id */
  team_id: number;
  /** 用户id */
  user_id: number;
}

export interface ReqTeamMemberEnable {
  /** 顶级团队id */
  team_id: number;
  /** 用户id */
  user_id: number;
}

export interface ReqTeamMemberRemove {
  /** 顶级团队id */
  team_id: number;
  /** 用户id */
  user_id: number;
}

export interface ReqTeamMemberRoleUpdate {
  /** 角色id; 1创建者;2管理者;3成员 */
  role_id?: number | undefined;
  /** 顶级团队id */
  team_id: number;
  /** 目标用户id */
  user_id: number;
}

export interface ReqTeamSwitch {
  /** 切换的团队id */
  team_id?: number | undefined;
}

export interface ReqUserAuthInfo {
  /** 低代码平台的ak */
  ak: string;
  /** jsapi 获取到的login_code */
  login_code: string;
}

export interface RespApp {
  /** 应用权益 */
  app_rights?: RespAppRightsVersion | undefined;
  /** 创建时间 */
  create_time?: number | undefined;
  /** 是否从模板创建 */
  is_tpl_app?: boolean | undefined;
  /** 是否工作区管理员； 1是；0否 */
  is_ws_admin?: number | undefined;
  /** 应用图标 */
  logo?: string | undefined;
  /** 应用名称 */
  name?: string | undefined;
  /** 低代码平台id */
  platform_id?: string | undefined;
  /** 应用所在的顶级团队id */
  team_id?: number | undefined;
  /** 应用id */
  third_app_id?: string | undefined;
  /** 应用所在的三方工作区id */
  third_ws_id?: string | undefined;
  /** 如果是从模板创建的_所属的模板id */
  tpl_id?: string | undefined;
  /** 如果是从模板创建的_模板的名称 */
  tpl_name?: string | undefined;
  /** 所属工作区名字 */
  work_space_name?: string | undefined;
  /** 工作区创建者名称 */
  workspace_owner_name?: string | undefined;
}

export interface RespAppCreate {
  /** 低代码服务商标识 */
  platform_id?: string | undefined;
  /** 对应的顶级团队的id */
  team_id?: number | undefined;
  /** 应用id */
  third_app_id?: string | undefined;
  /** 应用名称 */
  third_app_name?: string | undefined;
  /** 三方工作区id */
  ws_id?: string | undefined;
}

export interface RespAppRightsVersion {
  /** 应用付费信息 */
  app_paid_ver?: PaidVersion | undefined;
  /** 叠加权益结束时间 */
  end_time?: number | undefined;
  /** 是否应用单购 */
  is_app_single_purchase?: boolean | undefined;
  /** 叠加权益结束时间是否过期 */
  is_end_time_expired?: boolean | undefined;
  /** 是否免费;免费显示无限期和无支付入口 */
  is_free?: boolean | undefined;
  /** 叠加权益_是否试用期 */
  is_trial?: boolean | undefined;
  /** 叠加权益是否有效付费期；1是；0否 */
  is_valid_paid_period?: boolean | undefined;
  /** 叠加权益开始时间 */
  start_time?: number | undefined;
  /** 平台付费信息 */
  team_paid_ver?: PaidVersion | undefined;
  /** 三方应用id */
  third_app_id?: string | undefined;
  /** 配置的总试用天数 */
  trial_days?: number | undefined;
  /** 叠加权益_当正在试用期时_已经试用的天数 */
  trial_period?: number | undefined;
  /** 默认的工作区人数；平台（工作区）套餐过期时。 */
  trial_team_member_cnt?: number | undefined;
  /** 试用（默认）的平台版套餐名字; 平台套餐过期时显示 */
  trial_team_member_subject?: string | undefined;
}

export interface RespBanner {
  /** 应用名称 */
  app_name?: string | undefined;
  /** 应用appid */
  appid?: string | undefined;
  /** 是否可以关闭的 */
  closeable?: number | undefined;
  /** 左侧图 */
  image_left?: string | undefined;
  /** 右侧图 */
  image_right?: string | undefined;
  /** 图片 */
  image_url?: string | undefined;
  /** 推荐应用开关_0是关闭_1是开启应用_2是打开url */
  rec_switch?: number | undefined;
  /** 轮播顺序 */
  sequence?: number | undefined;
  /** 支持跳转的url */
  url?: string | undefined;
}

export interface RespBanners {
  banners?: RespBanner[] | undefined;
  /** 整个推广区是否可关闭 */
  is_banners_closeable?: number | undefined;
}

export interface RespCategory {
  /** 分类id */
  id?: number | undefined;
  /** 名字 */
  name?: string | undefined;
  /** 排序权重 */
  sequence?: number | undefined;
  /** 应用排序的方式；1按照配置顺序排序 */
  tpl_app_order_type?: number | undefined;
}

export interface RespInvitePartner {
  /** 团队id */
  partner_id?: number | undefined;
}

export interface RespMiddlePageAppPreCheck {
  cookie_set_url?: string | undefined;
  /** 跳转的三方应用链接 */
  forward_link?: string | undefined;
  /** 低代码平台对应的appid */
  open_app_id?: string | undefined;
  /** 工作区名称 */
  team_name?: string | undefined;
}

export interface RespPaymentConfig {
  /** 应用和平台混合版 */
  mix_team_app_mode?: string | undefined;
  /** 纯平台版 */
  pure_team_mode?: string | undefined;
  /** 轻流平台id */
  qingflow_platform_id?: string | undefined;
  /** 配额版 */
  quota_mode?: string | undefined;
}

export interface RespPlatform {
  /** 简介 */
  brief_intro?: string | undefined;
  /** 图标 */
  logo?: string | undefined;
  /** 名称 */
  name?: string | undefined;
  /** 低代码平台id */
  platform_id?: string | undefined;
}

export interface RespServerAppAccessRedirectUrl {
  /** 重定向的地址 */
  redirect_url?: string | undefined;
}

export interface RespServerAppRights {
  /** 权益起始生效时间 */
  create_time?: number | undefined;
  /** 结束时间 */
  end_time?: number | undefined;
  /** 套餐id */
  member_id?: number | undefined;
  /** 开始时间 */
  start_time?: number | undefined;
  /** 套餐名称 */
  subject?: string | undefined;
  thr?: string | undefined;
}

export interface RespServerAppRightsVersion {
  /** 应用付费信息 */
  app_paid_ver?: PaidVersion | undefined;
  /** 叠加权益结束时间 */
  end_time?: number | undefined;
  /** 是否应用单购 */
  is_app_single_purchase?: boolean | undefined;
  /** 叠加权益结束时间是否过期 */
  is_end_time_expired?: boolean | undefined;
  /** 是否免费;免费显示无限期和无支付入口 */
  is_free?: boolean | undefined;
  /** 叠加权益_是否试用期 */
  is_trial?: boolean | undefined;
  /** 叠加权益是否有效付费期；1是；0否 */
  is_valid_paid_period?: boolean | undefined;
  /** 叠加权益开始时间 */
  start_time?: number | undefined;
  /** 平台付费信息 */
  team_paid_ver?: PaidVersion | undefined;
  /** 三方应用id */
  third_app_id?: string | undefined;
  /** 模板信息 */
  tpl_info?: RespTpl | undefined;
  /** 配置的总试用天数 */
  trial_days?: number | undefined;
  /** 叠加权益_当正在试用期时_已经试用的天数 */
  trial_period?: number | undefined;
  /** 默认的工作区人数；平台（工作区）套餐过期时。 */
  trial_team_member_cnt?: number | undefined;
  /** 试用（默认）的平台版套餐名字; 平台套餐过期时显示 */
  trial_team_member_subject?: string | undefined;
}

export interface RespServerTeamRights {
  /** 人数 */
  cnt?: number | undefined;
  /** 权益起始生效时间 */
  create_time?: number | undefined;
  /** 权益到期时间 */
  end_time?: number | undefined;
  /** 当前套餐id */
  member_id?: number | undefined;
  /** 权益开始时间 */
  start_time?: number | undefined;
  /** 套餐信息 */
  subject?: string | undefined;
  /** 团队id */
  team_id?: number | undefined;

  /** 叠加权益_是否试用期 */
  is_trial?: boolean | undefined;
}

export interface RespTeam {
  /** 是否被禁用；1否；0是 */
  is_enable?: number | undefined;
  /** 工作区是否是用户创建的 */
  is_owner?: number | undefined;
  /** 工作区名称 */
  name?: string | undefined;
  /** 归属人名字 */
  owner_name?: string | undefined;
  /** 团队关联的公共邀请团队id */
  partner_id?: number | undefined;
  /** 团队中的角色id; 1创建者;2管理者;3成员 */
  role_id?: number | undefined;
  /** 用户顶级团队id */
  team_id?: number | undefined;
}

export interface RespTeamMember {
  /** 用户头像 */
  avatar?: string | undefined;
  /** 状态; 0 禁用;1启用 */
  is_enable?: number | undefined;
  /** 用户昵称 */
  nick_name?: string | undefined;
  /** 角色id; 1创建者;2管理者;成员 */
  role_id?: number | undefined;
  /** 用户userid */
  userid?: number | undefined;
}

export interface RespTeamQuota {
  /** 数量; 数据存储-W; 附件容量-G ;邮件-封;短信-数量 */
  count?: number | undefined;
  /** 配额类型；1数据存储；2附件容量；3短信；4邮件 */
  quota?: number | undefined;
}

export interface RespTeamRights {
  /** 人数 */
  cnt?: number;
  /** 创建时间 */
  create_time?: number | undefined;
  /** 权益到期时间 */
  end_time?: number | undefined;
  /** 权益结束时间是否过期 */
  is_end_time_expired?: boolean | undefined;
  /** 是否顶级套餐 */
  is_top_member?: boolean | undefined;
  is_top_member_cnt?: boolean | undefined;
  /** 当前套餐id */
  member_id?: number | undefined;
  /** 权益开始时间 */
  start_time?: number | undefined;
  /** 套餐信息 */
  subject?: string;
  /** 所有应用可试用天数 */
  trial_days?: number | undefined;
  /** 体验版的套餐名称 */
  trial_member_subject?: string | undefined;

  /** 权益标识 */
  member_level: string;

  /** 叠加权益_是否试用期 */
  is_trial?: boolean | undefined;

  /** 距离过期天数 */
  expired_near_days?: number | undefined;
}

export interface RespTeamStatics {
  /** 当前团队信息 */
  curr_team_info?: RespTeam | undefined;
  /** 团队的应用列表 */
  team_apps?: RespApp[] | undefined;
  /** 团队配额信息 */
  team_quotas?: RespTeamQuota[] | undefined;
  /** 团队权益信息 */
  team_rights?: RespTeamRights | undefined;
  /** 团队成员 */
  team_users?: RespTeamUsersInfo | undefined;
  /** 用户团队列表 */
  user_teams?: RespTeam[] | undefined;

  /** 试用/套餐过期推送配置 */
  notice?: RespTeamExpireNotice | undefined;
}

export interface RespTeamExpireNotice {
  /** 是否需要过期推送 */
  is_need_notice?: boolean | undefined;
}

export interface RespTeamUsersInfo {
  /** 成员启用数量 */
  member_enable_num?: number | undefined;
  /** 成员总数 */
  member_num?: number | undefined;
  /** 成员全部头像列表 */
  member_pics?: string[] | undefined;
  /** 默认套餐的人数 */
  trial_team_member_cnt?: number | undefined;
}

export interface RespTpl {
  /** 模板id */
  tpl_id?: string | undefined;
  /** 模板名称 */
  tpl_name?: string | undefined;
}

export interface RespTplApp {
  /** 简介 */
  brief_intro?: string | undefined;
  /** 分类名称 */
  category_name?: string | undefined;
  /** 图标 */
  icon?: string | undefined;
  /** 安装次数 */
  install_cnt?: number | undefined;
  /** 搜索关键词；逗号分隔 */
  key_words?: string | undefined;
  /** 标签 */
  labels?: string[] | undefined;
  /** 模板名称 */
  name?: string | undefined;
  /** 低代码平台id */
  platform_id?: string | undefined;
  /** 功能预览图片 */
  pre_view_img?: string | undefined;
  /** 模板id */
  tpl_id?: string | undefined;
}

export interface RespUserAuthInfo {
  avatar?: string | undefined;
  /** 三方账号did */
  did?: string | undefined;
  nick_name?: string | undefined;
}

export interface RespUserInfo {
  /** 用户头像 */
  avatar?: string | undefined;
  /** 用户did */
  did?: string | undefined;
  /** 用户昵称 */
  nick_name?: string | undefined;
  /** 用户userid */
  userid?: number | undefined;
}

export interface Anonymous extends JSONResult {
  data?: RespAppCreate | undefined;
}

export interface Anonymous2 extends JSONResult {
  data?: RespApp[] | undefined;
}

export interface Anonymous3 extends JSONResult {
  data?: RespAppRightsVersion | undefined;
}

export interface Anonymous4 extends JSONResult {
  data?: RespBanners | undefined;
}

export interface Anonymous5 extends JSONResult {
  data?: string[] | undefined;
}

export interface Anonymous6 extends JSONResult {
  data?: RespCategory[] | undefined;
}

export interface Anonymous7 extends JSONResult {
  data?: RespInvitePartner | undefined;
}

export interface Anonymous8 extends JSONResult {
  data?: RespPaymentConfig | undefined;
}

export interface Anonymous9 extends JSONResult {
  data?: RespPlatform[] | undefined;
}

export interface Anonymous10 extends JSONResult {
  data?: RespServerAppRights | undefined;
}

export interface Anonymous11 extends JSONResult {
  data?: RespServerAppRightsVersion | undefined;
}

export interface Anonymous12 extends JSONResult {
  data?: number | undefined;
}

export interface Anonymous13 extends JSONResult {
  data?: RespServerTeamRights | undefined;
}

export interface Anonymous14 extends JSONResult {
  data?: RespTeam[] | undefined;
}

export interface Anonymous15 extends JSONResult {
  data?: RespTeamMember[] | undefined;
}

export interface Anonymous16 extends JSONResult {
  data?: RespTeamStatics | undefined;
}

export interface Anonymous17 extends JSONResult {
  data?: RespTplApp | undefined;
}

export interface Anonymous18 extends JSONResult {
  data?: RespTplApp[] | undefined;
}

export interface Anonymous19 extends JSONResult {
  data?: RespUserAuthInfo | undefined;
}

export interface Anonymous20 extends JSONResult {
  data?: RespUserInfo | undefined;
}

export interface Anonymous21 extends JSONResult {
  data?: RespAppCreate | undefined;
}

export interface Anonymous22 extends JSONResult {
  data?: RespApp[] | undefined;
}

export interface Anonymous23 extends JSONResult {
  data?: RespApp[] | undefined;
}

export interface Anonymous24 extends JSONResult {
  data?: RespTplApp[] | undefined;
}

export interface Anonymous25 extends JSONResult {
  data?: string[] | undefined;
}

export interface Anonymous26 extends JSONResult {
  data?: RespMiddlePageAppPreCheck | undefined;
}

export interface Anonymous27 extends JSONResult {
  data?: RespServerAppAccessRedirectUrl | undefined;
}

export interface Anonymous28 extends JSONResult {
  data?: RespTplApp[] | undefined;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

type TypeRData<T> = T extends string ? ApiResponseDataType<undefined> : T;

/**
 * 【管理接口】将指定的应用权益过期
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostAdminApp_rightExpired<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: IAdminApp_rightExpiredParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/admin/app_right/expired`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 【管理接口】将指定将试用中的应用模拟过期
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostAdminApp_trialExpired<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: IAdminApp_trialExpiredParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/admin/app_trial/expired`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 【管理接口】将指定的团队平台权益过期
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostAdminTeam_rightExpired<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: IAdminTeam_rightExpiredParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/admin/team_right/expired`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 【管理接口】在指定的团队中创建指定模板应用
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostAdminTpl_appCreate<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: IAdminTpl_appCreateParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/admin/tpl_app/create`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 新建空白应用
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostAppCreate<T extends NonNullable<TypeRData<Anonymous>['data']>>(
  params?: IAppCreateParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/app/create`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 删除应用
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostAppDelete<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: IAppDeleteParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/app/delete`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 获取用户 我的应用列表
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetAppList<T extends NonNullable<TypeRData<Anonymous2>['data']>>(
  params?: undefined,
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/app/list`;
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 获取应用权益信息
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetAppRightsVersion<T extends NonNullable<TypeRData<Anonymous3>['data']>>(
  params?: IAppRightsVersionParams,
  config?: RequestCustomConfigType
) {
  const { platform_id, third_app_id, team_id, third_ws_id } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/app/rights/version?`;
  if (platform_id === undefined || platform_id === null)
    throw new Error('The parameter "platform_id" must be defined and cannot be null.');
  else _url += 'platform_id=' + encodeURIComponent('' + platform_id) + '&';
  if (third_app_id === undefined || third_app_id === null)
    throw new Error('The parameter "third_app_id" must be defined and cannot be null.');
  else _url += 'third_app_id=' + encodeURIComponent('' + third_app_id) + '&';
  if (team_id === undefined || team_id === null)
    throw new Error('The parameter "team_id" must be defined and cannot be null.');
  else _url += 'team_id=' + encodeURIComponent('' + team_id) + '&';
  if (third_ws_id === undefined || third_ws_id === null)
    throw new Error('The parameter "third_ws_id" must be defined and cannot be null.');
  else _url += 'third_ws_id=' + encodeURIComponent('' + third_ws_id) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 获取banner轮播图列表
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetBannerList<T extends NonNullable<TypeRData<Anonymous4>['data']>>(
  params?: undefined,
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/banner/list`;
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 用户清空历史搜索记录
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostBannerUserHot_searchDelete<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: IBannerUserHot_searchDeleteParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/banner/user/hot_search/delete`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 获取用户历史搜索记录
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetBannerUserHot_searchHistory<T extends NonNullable<TypeRData<Anonymous5>['data']>>(
  params?: undefined,
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/banner/user/hot_search/history`;
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 黑名单检查
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostBlack_listInspect<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: IBlack_listInspectParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/black_list/inspect`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 获取全部启用的分类列表
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetCategoryList<T extends NonNullable<TypeRData<Anonymous6>['data']>>(
  params?: undefined,
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/category/list`;
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 获取用于公共邀请的团队id
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetInvitePartner<T extends NonNullable<TypeRData<Anonymous7>['data']>>(
  params?: IInvitePartnerParams,
  config?: RequestCustomConfigType
) {
  const { team_id, did } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/invite/partner?`;
  if (team_id === undefined || team_id === null)
    throw new Error('The parameter "team_id" must be defined and cannot be null.');
  else _url += 'team_id=' + encodeURIComponent('' + team_id) + '&';
  if (did === undefined || did === null) throw new Error('The parameter "did" must be defined and cannot be null.');
  else _url += 'did=' + encodeURIComponent('' + did) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 获取支付配置
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetPaymentConfig<T extends NonNullable<TypeRData<Anonymous8>['data']>>(
  params?: undefined,
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/payment/config`;
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 获取低代码服务商列表
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetPlatformList<T extends NonNullable<TypeRData<Anonymous9>['data']>>(
  params?: undefined,
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/platform/list`;
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 获取应用版支付权益信息
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetServerAppRights<T extends NonNullable<TypeRData<Anonymous10>['data']>>(
  params?: IServerAppRightsParams,
  config?: RequestCustomConfigType
) {
  const { platform_id, third_app_id } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/server/app/rights?`;
  if (platform_id === undefined || platform_id === null)
    throw new Error('The parameter "platform_id" must be defined and cannot be null.');
  else _url += 'platform_id=' + encodeURIComponent('' + platform_id) + '&';
  if (third_app_id === undefined || third_app_id === null)
    throw new Error('The parameter "third_app_id" must be defined and cannot be null.');
  else _url += 'third_app_id=' + encodeURIComponent('' + third_app_id) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 应用套餐权益增益
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostServerAppRightsIncrease<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: IServerAppRightsIncreaseParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/server/app/rights/increase`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 获取应用叠加权益信息
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetServerAppRightsVersion<T extends NonNullable<TypeRData<Anonymous11>['data']>>(
  params?: IServerAppRightsVersionParams,
  config?: RequestCustomConfigType
) {
  const { platform_id, third_app_id, team_id, tpl_id } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/server/app/rights/version?`;
  if (platform_id === undefined || platform_id === null)
    throw new Error('The parameter "platform_id" must be defined and cannot be null.');
  else _url += 'platform_id=' + encodeURIComponent('' + platform_id) + '&';
  if (third_app_id === undefined || third_app_id === null)
    throw new Error('The parameter "third_app_id" must be defined and cannot be null.');
  else _url += 'third_app_id=' + encodeURIComponent('' + third_app_id) + '&';
  if (team_id === undefined || team_id === null)
    throw new Error('The parameter "team_id" must be defined and cannot be null.');
  else _url += 'team_id=' + encodeURIComponent('' + team_id) + '&';
  if (tpl_id !== undefined) _url += 'tpl_id=' + encodeURIComponent('' + tpl_id) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 确认邀请回调地址
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostServerInviteConfirmCb<T extends NonNullable<TypeRData<Anonymous12>['data']>>(
  params?: IServerInviteConfirmCbParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/server/invite/confirm/cb`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 支付回调
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostServerPayOrderCb<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: IServerPayOrderCbParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/server/pay/order/cb`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 订单预注册
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostServerPaymentRegisterOrder<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: IServerPaymentRegisterOrderParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/server/payment/register/order`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 获取团队（工作区权益）
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetServerTeamRights<T extends NonNullable<TypeRData<Anonymous13>['data']>>(
  params?: IServerTeamRightsParams,
  config?: RequestCustomConfigType
) {
  const { team_id } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/server/team/rights?`;
  if (team_id === undefined || team_id === null)
    throw new Error('The parameter "team_id" must be defined and cannot be null.');
  else _url += 'team_id=' + encodeURIComponent('' + team_id) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 团队套餐权益增益
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostServerTeamRightsIncrease<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: IServerTeamRightsIncreaseParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/server/team/rights/increase`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 创建工作区
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostTeamCreate<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: ITeamCreateParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/team/create`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 获取用户在指定低代码平台创建或者加入为管理员的工作区
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetTeamList<T extends NonNullable<TypeRData<Anonymous14>['data']>>(
  params?: ITeamListParams,
  config?: RequestCustomConfigType
) {
  const { platform_id } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/team/list?`;
  if (platform_id !== undefined) _url += 'platform_id=' + encodeURIComponent('' + platform_id) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 禁用团队成员
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostTeamMemberDisable<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: ITeamMemberDisableParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/team/member/disable`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 启用团队成员
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostTeamMemberEnable<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: ITeamMemberEnableParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/team/member/enable`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 移除团队成员
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostTeamMemberRemove<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: ITeamMemberRemoveParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/team/member/remove`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 更改团队成员角色
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostTeamMemberRoleUpdate<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: ITeamMemberRoleUpdateParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/team/member/role/update`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 获取团队成员
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetTeamMembers<T extends NonNullable<TypeRData<Anonymous15>['data']>>(
  params?: ITeamMembersParams,
  config?: RequestCustomConfigType
) {
  const { team_id } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/team/members?`;
  if (team_id === undefined || team_id === null)
    throw new Error('The parameter "team_id" must be defined and cannot be null.');
  else _url += 'team_id=' + encodeURIComponent('' + team_id) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 新建页获取工作区数据信息
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetTeamStatics<T extends NonNullable<TypeRData<Anonymous16>['data']>>(
  params?: ITeamStaticsParams,
  config?: RequestCustomConfigType
) {
  const { partner_id } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/team/statics?`;
  if (partner_id !== undefined) _url += 'partner_id=' + encodeURIComponent('' + partner_id) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 切换工作区
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostTeamSwitch<T extends NonNullable<TypeRData<JSONResult>['data']>>(
  params?: ITeamSwitchParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/team/switch`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 获取模板应用详情
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetTpl_appDetail<T extends NonNullable<TypeRData<Anonymous17>['data']>>(
  params?: ITpl_appDetailParams,
  config?: RequestCustomConfigType
) {
  const { tpl_id, platform_id } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/tpl_app/detail?`;
  if (tpl_id === undefined || tpl_id === null)
    throw new Error('The parameter "tpl_id" must be defined and cannot be null.');
  else _url += 'tpl_id=' + encodeURIComponent('' + tpl_id) + '&';
  if (platform_id === undefined || platform_id === null)
    throw new Error('The parameter "platform_id" must be defined and cannot be null.');
  else _url += 'platform_id=' + encodeURIComponent('' + platform_id) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 根据关键词搜索模板应用
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetTpl_appSearch<T extends NonNullable<TypeRData<Anonymous18>['data']>>(
  params?: ITpl_appSearchParams,
  config?: RequestCustomConfigType
) {
  const { key_word } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/tpl_app/search?`;
  if (key_word === undefined || key_word === null)
    throw new Error('The parameter "key_word" must be defined and cannot be null.');
  else _url += 'key_word=' + encodeURIComponent('' + key_word) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 获取用户授权信息,用于三方页面获取用户信息
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostUserAuthInfo<T extends NonNullable<TypeRData<Anonymous19>['data']>>(
  params?: IUserAuthInfoParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/user/auth/info`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 获取当前登录用户基本信息
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetUserInfo<T extends NonNullable<TypeRData<Anonymous20>['data']>>(
  params?: undefined,
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/user/info`;
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

export interface IAdminApp_rightExpiredParams {
  /**
   * 【管理接口】将指定的应用权益过期
   */
  req: ReqAdminAppRightExpired;
}
export interface IAdminApp_trialExpiredParams {
  /**
   * 【管理接口】将指定将试用中的应用模拟过期
   */
  req: ReqAdminAppTrialExpired;
}
export interface IAdminTeam_rightExpiredParams {
  /**
   * 【管理接口】将指定的团队平台权益过期
   */
  req: ReqAdminTeamRightExpired;
}
export interface IAdminTpl_appCreateParams {
  /**
   * 【管理接口】在指定的团队中创建指定模板应用
   */
  req: ReqAdminTplAppCreate;
}
export interface IAppCreateParams {
  /**
   * 新建空白应用
   */
  req: ReqAppCreate;
}
export interface IAppDeleteParams {
  /**
   * 删除应用
   */
  req: ReqAppDelete;
}
export interface IAppListParams {}
export interface IAppRightsVersionParams {
  /**
   * 低代码平台id
   */
  platform_id: string;
  /**
   * 三方应用id
   */
  third_app_id: string;
  /**
   * 应用对应的团队id,检验需要
   */
  team_id: number;
  /**
   * 三方工作区id
   */
  third_ws_id: string;
}
export interface IBannerListParams {}
export interface IBannerUserHot_searchDeleteParams {
  /**
   * 用户清空历史搜索记录
   */
  req: ReqBannerUserHotSearchDelete;
}
export interface IBannerUserHot_searchHistoryParams {}
export interface IBlack_listInspectParams {
  /**
   * 黑名单检查
   */
  req: ReqBlackListInspect;
}
export interface ICategoryListParams {}
export interface IInvitePartnerParams {
  /**
   * 团队id
   */
  team_id: number;
  /**
   * DID
   */
  did: string;
}
export interface IPaymentConfigParams {}
export interface IPlatformListParams {}
export interface IServerAppRightsParams {
  /**
   * 平台id
   */
  platform_id: string;
  /**
   * 应用id
   */
  third_app_id: string;
}
export interface IServerAppRightsIncreaseParams {
  /**
   * 应用套餐权益增益
   */
  req: ReqServerAppRightsIncrease;
}
export interface IServerAppRightsVersionParams {
  /**
   * 低代码平台id
   */
  platform_id: string;
  /**
   * 三方应用id
   */
  third_app_id: string;
  /**
   * 应用对应的团队id,检验需要
   */
  team_id: number;
  /**
   * 模板id; 存在时，返回模板相关信息
   */
  tpl_id?: string | null | undefined;
}
export interface IServerInviteConfirmCbParams {
  /**
   * 确认邀请回调地址
   */
  req: ReqServerInviteConfirmCb;
}
export interface IServerPayOrderCbParams {
  /**
   * 支付回调
   */
  req: ReqServerPayOrderCb;
}
export interface IServerPaymentRegisterOrderParams {
  /**
   * 订单预注册
   */
  req: ReqServerPaymentRegisterOrder;
}
export interface IServerTeamRightsParams {
  /**
   * 团队id
   */
  team_id: number;
}
export interface IServerTeamRightsIncreaseParams {
  /**
   * 团队套餐权益增益
   */
  req: ReqServerTeamRightsIncrease;
}
export interface ITeamCreateParams {
  /**
   * 创建工作区
   */
  req: ReqTeamCreate;
}
export interface ITeamListParams {
  /**
   * 低代码平台id
   */
  platform_id?: string | null | undefined;
}
export interface ITeamMemberDisableParams {
  /**
   * 禁用团队成员
   */
  req: ReqTeamMemberDisable;
}
export interface ITeamMemberEnableParams {
  /**
   * 启用团队成员
   */
  req: ReqTeamMemberEnable;
}
export interface ITeamMemberRemoveParams {
  /**
   * 移除团队成员
   */
  req: ReqTeamMemberRemove;
}
export interface ITeamMemberRoleUpdateParams {
  /**
   * 更改团队成员角色
   */
  req: ReqTeamMemberRoleUpdate;
}
export interface ITeamMembersParams {
  /**
   * 顶级团队id
   */
  team_id: number;
}
export interface ITeamStaticsParams {
  /**
   * 团队id,当存在时。获取此partner_id对应工作区的相关信息。
   */
  partner_id?: number | null | undefined;
}
export interface ITeamSwitchParams {
  /**
   * 切换工作区
   */
  req: ReqTeamSwitch;
}
export interface ITpl_appDetailParams {
  /**
   * 模板id
   */
  tpl_id: string;
  /**
   * 三方平台id
   */
  platform_id: string;
}
export interface ITpl_appSearchParams {
  /**
   * 搜索关键词
   */
  key_word: string;
}
export interface IUserAuthInfoParams {
  /**
   * 获取用户授权信息,用于三方页面获取用户信息
   */
  req: ReqUserAuthInfo;
}
export interface IUserInfoParams {}

/**
 * 新建模板应用
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostAppCreateBy_tpl<T extends NonNullable<TypeRData<Anonymous21>['data']>>(
  params?: IAppCreateBy_tplParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/app/create/by_tpl`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

/**
 * 获取用户 基于模板具有访问权限的应用列表
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetAppListBy_tpl<T extends NonNullable<TypeRData<Anonymous22>['data']>>(
  params?: IAppListBy_tplParams,
  config?: RequestCustomConfigType
) {
  const { platform_id, tpl_id } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/app/list/by_tpl?`;
  if (platform_id === undefined || platform_id === null)
    throw new Error('The parameter "platform_id" must be defined and cannot be null.');
  else _url += 'platform_id=' + encodeURIComponent('' + platform_id) + '&';
  if (tpl_id === undefined || tpl_id === null)
    throw new Error('The parameter "tpl_id" must be defined and cannot be null.');
  else _url += 'tpl_id=' + encodeURIComponent('' + tpl_id) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 获取用户指定团队基于模板具有访问权限的应用列表
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetTeamAppListBy_tpl<T extends NonNullable<TypeRData<Anonymous23>['data']>>(
  params?: ITeamAppListBy_tplParams,
  config?: RequestCustomConfigType
) {
  const { platform_id, tpl_id, team_id } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/team/app/list/by_tpl?`;
  if (platform_id === undefined || platform_id === null)
    throw new Error('The parameter "platform_id" must be defined and cannot be null.');
  else _url += 'platform_id=' + encodeURIComponent('' + platform_id) + '&';
  if (tpl_id === undefined || tpl_id === null)
    throw new Error('The parameter "tpl_id" must be defined and cannot be null.');
  else _url += 'tpl_id=' + encodeURIComponent('' + tpl_id) + '&';
  if (team_id === undefined || team_id === null)
    throw new Error('The parameter "team_id" must be defined and cannot be null.');
  else _url += 'team_id=' + encodeURIComponent('' + team_id) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

/**
 * 按照分类获取分类下的模板应用列表
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetTpl_appBy_category<T extends NonNullable<TypeRData<Anonymous24>['data']>>(
  params?: ITpl_appBy_categoryParams,
  config?: RequestCustomConfigType
) {
  const { category_id } = params || {};
  // 请求地址
  let _url = `/lcdp/v1/tpl_app/by_category?`;
  if (category_id === undefined || category_id === null)
    throw new Error('The parameter "category_id" must be defined and cannot be null.');
  else _url += 'category_id=' + encodeURIComponent('' + category_id) + '&';
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

export interface IAppCreateBy_tplParams {
  /**
   * 新建模板应用
   */
  req: ReqAppCreateByTpl;
}
export interface IAppListBy_tplParams {
  /**
   * 低代码平台id
   */
  platform_id: string;
  /**
   * 模板id
   */
  tpl_id: string;
}
export interface ITeamAppListBy_tplParams {
  /**
   * 低代码平台id
   */
  platform_id: string;
  /**
   * 模板id
   */
  tpl_id: string;
  /**
   * 团队id
   */
  team_id: number;
}
export interface ITpl_appBy_categoryParams {
  /**
   * 分类id
   */
  category_id: number;
}

/**
 * 获取所有热搜词
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetBannerHot_search<T extends NonNullable<TypeRData<Anonymous25>['data']>>(
  params?: undefined,
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/banner/hot_search`;
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

export interface IBannerHot_searchParams {}

/**
 * 中间页，访问应用预检查接口
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostMiddle_pageAppPre_check<T extends NonNullable<TypeRData<Anonymous26>['data']>>(
  params?: IMiddle_pageAppPre_checkParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/middle_page/app/pre_check`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

export interface IMiddle_pageAppPre_checkParams {
  /**
   * 中间页，访问应用预检查接口
   */
  req: ReqMiddlePageAppPreCheck;
}

/**
 * 获取访问令牌绑定的访问应用的重定向链接
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiPostServerApp_accessRedirect_url<T extends NonNullable<TypeRData<Anonymous27>['data']>>(
  params?: IServerApp_accessRedirect_urlParams['req'],
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/server/app_access/redirect_url`;
  _url = _url.replace(/[?&]$/g, '');

  const _content = params || {};

  const _options = {
    data: _content,
    method: 'POST' as const,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return request<T>(_url, _options, config);
}

export interface IServerApp_accessRedirect_urlParams {
  /**
   * 获取访问令牌绑定的访问应用的重定向链接
   */
  req: ReqServerAppAccessRedirectUrl;
}

/**
 * 获取分类列表第一分类的模板应用[优化首屏]
 * @param params ajax请求需要的参数对象
 * @return OK
 */
export function apiGetTpl_appBy_first_category<T extends NonNullable<TypeRData<Anonymous28>['data']>>(
  params?: undefined,
  config?: RequestCustomConfigType
) {
  // 请求地址
  let _url = `/lcdp/v1/tpl_app/by_first_category`;
  _url = _url.replace(/[?&]$/g, '');

  const _options = {};

  return request<T>(_url, _options, config);
}

export interface ITpl_appBy_first_categoryParams {}
